import React, { useEffect, useState } from "react";
import "../../assets/styles/navbar.css";
import mainLogo from "../../assets/images/maalogo.png";
import { Link, useLocation } from "react-router-dom";
import { config } from "../../pages/config";

const Navbar = ({ inner }) => {
  const location = useLocation("");

  const [sideMenu, setSideMenu] = useState(false);
  const [sideMenuMobile, setSideMenuMobile] = useState(false);

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <header
        id="header"
        className={`headroom ${isSticky ? 'sticky' : ''}`}
      >
        <div className="header-inner">
          <div className="container">
            <nav className="navbar navbar-expand-md navbar-light">
              <Link
                to={`${config.appUrl}`}
                className="navbar-brand d-flex gap-3 align-items-center"
              >
                <img className="img-fluid" src={mainLogo} alt="logo" width="85" style={{ color: "transparent" }} />
              </Link>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav ms-auto">
                  <li
                    className={`nav-item ${location?.pathname == `${config.appUrl}` ? "active" : ""
                      }`}
                  >
                    <Link className="nav-link" to={`${config.appUrl}`}>
                      Home <i className="fa-solid fa-chevron-down"></i>
                    </Link>
                  </li>
                  <li
                    className={`nav-item ${location?.pathname == `${config.appUrl}about-us`
                      ? "active"
                      : ""
                      }`}
                  >
                    <Link className="nav-link" to={`${config.appUrl}about-us`}>
                      About Us <i className="fa-solid fa-chevron-down"></i>
                    </Link>
                  </li>
                  <li
                    className={`nav-item ${location?.pathname == `${config.appUrl}collections`
                      ? "active"
                      : ""
                      }`}
                  >
                    <Link className="nav-link" to={`${config.appUrl}collections`}>
                      Jewellery Collections <i className="fa-solid fa-chevron-down"></i>
                    </Link>
                  </li>
                  <li
                    className={`nav-item ${location?.pathname == `${config.appUrl}contact-us`
                      ? "active"
                      : ""
                      }`}
                  >
                    <Link className="nav-link" to={`${config.appUrl}contact-us`}>
                      Contact
                    </Link>
                  </li>
                </ul>
                {/* <div className="others-option">
                  <a href="tel:+91-8849835366" rel="noreferrer" className="btn blue-line-btn">
                    <i className="bi bi-phone" aria-hidden="true"></i> +91 88498 35366 </a>
                </div> */}
              </div>
              <div className="mobile-action d-block d-xl-none">
                <div className="mobile-hamburger">
                  <a className="hamburger" onClick={() => setSideMenuMobile(true)}>
                    <span className="hamburger-container">
                      <span className="hamburger-inner"></span>
                      <span className="hamburger-hidden"></span>
                    </span>
                  </a>
                </div>
              </div>
            </nav>
            <div
              class={`offcanvas main-menu-offcanvas offcanvas-end  ${sideMenuMobile ? "show" : ""
                }`}
            >
              <div className="offcanvas-header">
                <a className="navbar-brand d-flex gap-2 align-items-center">
                  <img className="img-fluid" width="110" src={mainLogo} alt="logo" />
                  <h4 className="mb-0"></h4>
                </a>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSideMenuMobile(false)}
                >
                  <i className="bi bi-x"></i>
                </button>
              </div>
              <div className="offcanvas-body">
                <div className="body-inner">
                  <nav className="navbar">
                    <ul className="navbar-nav w-100">
                      <li className="nav-item ">
                        <Link to={`${config.appUrl}`} className="nav-link">
                          Home
                        </Link>
                      </li>
                      <li className="nav-item ">
                        <Link to={`${config.appUrl}about-us`} className="nav-link">
                          About Us
                        </Link>
                      </li>
                      <li className="nav-item ">
                        <Link to={`${config.appUrl}collections`} className="nav-link">
                          Jewellery Collections
                        </Link>
                      </li>
                      <li className="nav-item ">
                        <Link to={`${config.appUrl}contact-us`} className="nav-link">
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </nav>
                  {/* <div className="bottom-info ">
                    <div className="contact-info border-0 pt-0">
                      <a href="tel:+91-8849835366" style={{ textDecoration: 'none' }} className="mail"><i className="bi bi-phone"></i>+91 88498 35366</a>
                      <a className="mail" href="mailto:info@cubextechnology.com">
                        <i className="bi bi-envelope"></i>info@cubextechnology.com
                      </a>
                      <span className="text">
                        Looking for collaboration for your next creative project?
                      </span>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
